export const invalidInstitutionNumber = function(value, field, model, messages=null) {
    if (value && !value.match(/^[0-9]{3}$/)) {
        if (!messages) {
            return ["Institution number must be 3 digits."];
        } else {
            return [messages.invalidInstitutionNumber];
        }
    }
    return [];
}

export const invalidAccountNumber = function(value, field, model, messages=null) {
    if (value && !value.match(/^[0-9]{7,12}$/)) {
        if (!messages) {
            return ["Account number must be between 7 and 12 digits."];
        } else {
            return [messages.invalidAccountNumber];
        }
    }
    return [];
}

export const invalidTransitNumber = function(value, field, model, messages=null) {
    if (value && !value.match(/^[0-9]{5}$/)) {
        if (!messages) {
            return ["Transit number must be 5 digits."];
        } else {
            return [messages.invalidTransitNumber];
        }
    }
    return [];
}
